import React from 'react';

/**
 * <PageHeader title="Properties" subtitle="Your rental portfolio."
 *             actions={<button className="btn-primary">New</button>} />
 */
const PageHeader = ({ title, subtitle, actions, breadcrumb }) => (
    <div className="mb-6">
        {breadcrumb && (
            <nav className="text-xs text-neutral-500 mb-2">
                {breadcrumb}
            </nav>
        )}
        <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="min-w-0">
                <h1 className="text-2xl font-semibold text-neutral-900 tracking-tight">{title}</h1>
                {subtitle && <p className="text-sm text-neutral-500 mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
    </div>
);

export default PageHeader;
